import Vue from 'vue'
import Vuex from 'vuex'
import { rejects } from 'assert';
import { resolve } from 'upath';
import { post, get, API_ENDPOINT, put, destroy} from './helpers/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user_id: null,
    user: 'null',
    api_token: null,
    avt_blagajne: [],
    loader: true
  },
  mutations: {
    
    setToken(state, api_token) {
      state.api_token = api_token
      localStorage.setItem('access_token', api_token)
    },

    setUserID(state, id) {
      state.user_id = id;
      localStorage.setItem('user_id', id);
    },

    setUser(state, user) {
      state.user = user
      localStorage.setItem('user', user)
    },

    setLoader(state, newState) {
      state.loader = newState
    },

    setAvtBlagajne(state, avt_blagajne) {
      state.avt_blagajne = avt_blagajne
    }


  },
  actions: {

    LOGIN (context, credentials) {
      return new Promise((resolve, reject) => {
        post(API_ENDPOINT + 'auth/login', credentials)
          .then(response => {
            context.commit('setToken', response.data.access_token)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    LOGOUT (context) {
      return new Promise ((resolve, reject) => {
        get(API_ENDPOINT + 'auth/logout')
          .then(response => {
            context.commit('setUserID', null)
            context.commit('setUser', null)
            context.commit('setToken', null)
            context.commit('setAvtBlagajne', [])
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    USER_DATA(context) {
      return new Promise((resolve, reject) => {
        get(API_ENDPOINT + 'user/info')
          .then(response => {

            context.commit('setUserID', response.data.data.id)
            context.commit('setUser', response.data.data.name)

            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    AVT_BLAGAJNE(context) {
      return new Promise((resolve, reject) => {
        get(API_ENDPOINT + 'avt-blagajne')
        .then(response => {
          var dataToCommit = []
          
          for(var i=0; i < response.data.data.length; i++)
          {
            if(response.data.data[i].zasedenost_avt_blagajne != null) {
              dataToCommit.push(response.data.data[i])
            }
          }
          
          context.commit('setAvtBlagajne', dataToCommit)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },

    AVT_BLAGAJNA(context) {
      return new Promise((resolve, reject) => {
          get(API_ENDPOINT + 'avt-blagajne/1105')
          .then(response => {
            context.commit('setAvtBlagajne', response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })

    },

    CURRENT_TIME(context) {
      return new Promise((resolve, reject) => {
          get(API_ENDPOINT + 'info/current-time')
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    AVT_BLAGAJNA_UPDATE(context, data) {
      return new Promise((resolve, reject) => {
        post(API_ENDPOINT + 'avt-blagajne', data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    }
  },

  getters: {

    user (state) {
      return state.user
    },

    userId (state) {
      return state.user_id
    },

    loader (state) {
      return state.loader
    },

    avtBlagajne (state) {
      return state.avt_blagajne
    }

  }
})
